module.exports = __webpack_public_path__ + "img/icon-distribuidores.e64ff7a2.svg";